export default __webpack_public_path__ + "static/media/github.35a32422.svg";